/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  assertIsInstructionWithAccounts,
  containsBytes,
  fixEncoderSize,
  getBytesEncoder,
  SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_ACCOUNT,
  SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_INSTRUCTION,
  SOLANA_ERROR__PROGRAM_CLIENTS__UNRECOGNIZED_INSTRUCTION_TYPE,
  SolanaError,
  type Address,
  type ClientWithPayer,
  type ClientWithRpc,
  type ClientWithTransactionPlanning,
  type ClientWithTransactionSending,
  type GetAccountInfoApi,
  type GetMultipleAccountsApi,
  type Instruction,
  type InstructionWithData,
  type ReadonlyUint8Array,
} from '@solana/kit';
import {
  addSelfFetchFunctions,
  addSelfPlanAndSendFunctions,
  type SelfFetchFunctions,
  type SelfPlanAndSendFunctions,
} from '@solana/program-client-core';
import {
  getAmmConfigCodec,
  getOracleStateCodec,
  getPoolCodec,
  getPositionCodec,
  type AmmConfig,
  type AmmConfigArgs,
  type OracleState,
  type OracleStateArgs,
  type Pool,
  type PoolArgs,
  type Position,
  type PositionArgs,
} from '../accounts';
import {
  getAddLiquidityInstructionAsync,
  getClosePositionInstruction,
  getCollectFeesInstructionAsync,
  getCollectProtocolFeesInstructionAsync,
  getCreatePositionInstructionAsync,
  getInitializeConfigInstructionAsync,
  getInitializeOracleInstructionAsync,
  getInitializePoolInstructionAsync,
  getInitializeSpotPoolInstructionAsync,
  getInitializeSpotPoolWithHookInstructionAsync,
  getOracleConsultInstructionAsync,
  getOracleUpdateInstructionAsync,
  getPauseInstruction,
  getPreviewSwapExactInInstruction,
  getRedeemProtocolSharesInstructionAsync,
  getRemoveLiquidityInstructionAsync,
  getSetFeesInstruction,
  getSetHookInstruction,
  getSwapExactInInstructionAsync,
  getTransferAdminInstruction,
  getUnpauseInstruction,
  getUpdateConfigInstruction,
  getWithdrawVaultExcessInstructionAsync,
  parseAddLiquidityInstruction,
  parseClosePositionInstruction,
  parseCollectFeesInstruction,
  parseCollectProtocolFeesInstruction,
  parseCreatePositionInstruction,
  parseInitializeConfigInstruction,
  parseInitializeOracleInstruction,
  parseInitializePoolInstruction,
  parseInitializeSpotPoolInstruction,
  parseInitializeSpotPoolWithHookInstruction,
  parseOracleConsultInstruction,
  parseOracleUpdateInstruction,
  parsePauseInstruction,
  parsePreviewSwapExactInInstruction,
  parseRedeemProtocolSharesInstruction,
  parseRemoveLiquidityInstruction,
  parseSetFeesInstruction,
  parseSetHookInstruction,
  parseSwapExactInInstruction,
  parseTransferAdminInstruction,
  parseUnpauseInstruction,
  parseUpdateConfigInstruction,
  parseWithdrawVaultExcessInstruction,
  type AddLiquidityAsyncInput,
  type ClosePositionInput,
  type CollectFeesAsyncInput,
  type CollectProtocolFeesAsyncInput,
  type CreatePositionAsyncInput,
  type InitializeConfigAsyncInput,
  type InitializeOracleAsyncInput,
  type InitializePoolAsyncInput,
  type InitializeSpotPoolAsyncInput,
  type InitializeSpotPoolWithHookAsyncInput,
  type OracleConsultAsyncInput,
  type OracleUpdateAsyncInput,
  type ParsedAddLiquidityInstruction,
  type ParsedClosePositionInstruction,
  type ParsedCollectFeesInstruction,
  type ParsedCollectProtocolFeesInstruction,
  type ParsedCreatePositionInstruction,
  type ParsedInitializeConfigInstruction,
  type ParsedInitializeOracleInstruction,
  type ParsedInitializePoolInstruction,
  type ParsedInitializeSpotPoolInstruction,
  type ParsedInitializeSpotPoolWithHookInstruction,
  type ParsedOracleConsultInstruction,
  type ParsedOracleUpdateInstruction,
  type ParsedPauseInstruction,
  type ParsedPreviewSwapExactInInstruction,
  type ParsedRedeemProtocolSharesInstruction,
  type ParsedRemoveLiquidityInstruction,
  type ParsedSetFeesInstruction,
  type ParsedSetHookInstruction,
  type ParsedSwapExactInInstruction,
  type ParsedTransferAdminInstruction,
  type ParsedUnpauseInstruction,
  type ParsedUpdateConfigInstruction,
  type ParsedWithdrawVaultExcessInstruction,
  type PauseInput,
  type PreviewSwapExactInInput,
  type RedeemProtocolSharesAsyncInput,
  type RemoveLiquidityAsyncInput,
  type SetFeesInput,
  type SetHookInput,
  type SwapExactInAsyncInput,
  type TransferAdminInput,
  type UnpauseInput,
  type UpdateConfigInput,
  type WithdrawVaultExcessAsyncInput,
} from '../instructions';

export const CPMM_PROGRAM_ADDRESS =
  '9PSxVPoPfnbZ8Q1uQhgS6ZxvBjFboZtebNsu34umxkgQ' as Address<'9PSxVPoPfnbZ8Q1uQhgS6ZxvBjFboZtebNsu34umxkgQ'>;

export enum CpmmAccount {
  AmmConfig,
  OracleState,
  Pool,
  Position,
}

export function identifyCpmmAccount(
  account: { data: ReadonlyUint8Array } | ReadonlyUint8Array,
): CpmmAccount {
  const data = 'data' in account ? account.data : account;
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([218, 244, 33, 104, 203, 203, 43, 111]),
      ),
      0,
    )
  ) {
    return CpmmAccount.AmmConfig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([97, 156, 157, 189, 194, 73, 8, 15]),
      ),
      0,
    )
  ) {
    return CpmmAccount.OracleState;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([241, 154, 109, 4, 17, 177, 109, 188]),
      ),
      0,
    )
  ) {
    return CpmmAccount.Pool;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([170, 188, 143, 228, 122, 64, 247, 208]),
      ),
      0,
    )
  ) {
    return CpmmAccount.Position;
  }
  throw new SolanaError(
    SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_ACCOUNT,
    { accountData: data, programName: 'cpmm' },
  );
}

export enum CpmmInstruction {
  AddLiquidity,
  ClosePosition,
  CollectFees,
  CollectProtocolFees,
  CreatePosition,
  InitializeConfig,
  InitializeOracle,
  InitializePool,
  InitializeSpotPool,
  InitializeSpotPoolWithHook,
  OracleConsult,
  OracleUpdate,
  Pause,
  PreviewSwapExactIn,
  RedeemProtocolShares,
  RemoveLiquidity,
  SetFees,
  SetHook,
  SwapExactIn,
  TransferAdmin,
  Unpause,
  UpdateConfig,
  WithdrawVaultExcess,
}

export function identifyCpmmInstruction(
  instruction: { data: ReadonlyUint8Array } | ReadonlyUint8Array,
): CpmmInstruction {
  const data = 'data' in instruction ? instruction.data : instruction;
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([181, 157, 89, 67, 143, 182, 52, 72]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.AddLiquidity;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([123, 134, 81, 0, 49, 68, 98, 98]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.ClosePosition;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([164, 152, 207, 99, 30, 186, 19, 182]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.CollectFees;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([22, 67, 23, 98, 150, 178, 70, 220]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.CollectProtocolFees;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([48, 215, 197, 153, 96, 203, 180, 133]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.CreatePosition;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([208, 127, 21, 1, 194, 190, 196, 70]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.InitializeConfig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([144, 223, 131, 120, 196, 253, 181, 99]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.InitializeOracle;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([95, 180, 10, 172, 84, 174, 232, 40]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.InitializePool;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([254, 243, 84, 29, 237, 165, 241, 217]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.InitializeSpotPool;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([98, 227, 206, 159, 252, 134, 77, 21]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.InitializeSpotPoolWithHook;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([239, 237, 255, 177, 142, 72, 96, 175]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.OracleConsult;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([85, 209, 248, 142, 186, 249, 120, 239]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.OracleUpdate;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([211, 22, 221, 251, 74, 121, 193, 47]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.Pause;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([50, 130, 31, 69, 147, 58, 222, 178]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.PreviewSwapExactIn;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([143, 253, 251, 77, 213, 178, 0, 225]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.RedeemProtocolShares;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([80, 85, 209, 72, 24, 206, 177, 108]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.RemoveLiquidity;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([137, 178, 49, 58, 0, 245, 242, 190]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.SetFees;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([175, 16, 187, 252, 19, 54, 111, 221]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.SetHook;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([104, 104, 131, 86, 161, 189, 180, 216]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.SwapExactIn;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([42, 242, 66, 106, 228, 10, 111, 156]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.TransferAdmin;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([169, 144, 4, 38, 10, 141, 188, 255]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.Unpause;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([29, 158, 252, 191, 10, 83, 219, 99]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.UpdateConfig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([235, 197, 247, 177, 137, 72, 135, 113]),
      ),
      0,
    )
  ) {
    return CpmmInstruction.WithdrawVaultExcess;
  }
  throw new SolanaError(
    SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_INSTRUCTION,
    { instructionData: data, programName: 'cpmm' },
  );
}

export type ParsedCpmmInstruction<
  TProgram extends string = '9PSxVPoPfnbZ8Q1uQhgS6ZxvBjFboZtebNsu34umxkgQ',
> =
  | ({
      instructionType: CpmmInstruction.AddLiquidity;
    } & ParsedAddLiquidityInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.ClosePosition;
    } & ParsedClosePositionInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.CollectFees;
    } & ParsedCollectFeesInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.CollectProtocolFees;
    } & ParsedCollectProtocolFeesInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.CreatePosition;
    } & ParsedCreatePositionInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.InitializeConfig;
    } & ParsedInitializeConfigInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.InitializeOracle;
    } & ParsedInitializeOracleInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.InitializePool;
    } & ParsedInitializePoolInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.InitializeSpotPool;
    } & ParsedInitializeSpotPoolInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.InitializeSpotPoolWithHook;
    } & ParsedInitializeSpotPoolWithHookInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.OracleConsult;
    } & ParsedOracleConsultInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.OracleUpdate;
    } & ParsedOracleUpdateInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.Pause;
    } & ParsedPauseInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.PreviewSwapExactIn;
    } & ParsedPreviewSwapExactInInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.RedeemProtocolShares;
    } & ParsedRedeemProtocolSharesInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.RemoveLiquidity;
    } & ParsedRemoveLiquidityInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.SetFees;
    } & ParsedSetFeesInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.SetHook;
    } & ParsedSetHookInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.SwapExactIn;
    } & ParsedSwapExactInInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.TransferAdmin;
    } & ParsedTransferAdminInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.Unpause;
    } & ParsedUnpauseInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.UpdateConfig;
    } & ParsedUpdateConfigInstruction<TProgram>)
  | ({
      instructionType: CpmmInstruction.WithdrawVaultExcess;
    } & ParsedWithdrawVaultExcessInstruction<TProgram>);

export function parseCpmmInstruction<TProgram extends string>(
  instruction: Instruction<TProgram> & InstructionWithData<ReadonlyUint8Array>,
): ParsedCpmmInstruction<TProgram> {
  const instructionType = identifyCpmmInstruction(instruction);
  switch (instructionType) {
    case CpmmInstruction.AddLiquidity: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.AddLiquidity,
        ...parseAddLiquidityInstruction(instruction),
      };
    }
    case CpmmInstruction.ClosePosition: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.ClosePosition,
        ...parseClosePositionInstruction(instruction),
      };
    }
    case CpmmInstruction.CollectFees: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.CollectFees,
        ...parseCollectFeesInstruction(instruction),
      };
    }
    case CpmmInstruction.CollectProtocolFees: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.CollectProtocolFees,
        ...parseCollectProtocolFeesInstruction(instruction),
      };
    }
    case CpmmInstruction.CreatePosition: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.CreatePosition,
        ...parseCreatePositionInstruction(instruction),
      };
    }
    case CpmmInstruction.InitializeConfig: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.InitializeConfig,
        ...parseInitializeConfigInstruction(instruction),
      };
    }
    case CpmmInstruction.InitializeOracle: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.InitializeOracle,
        ...parseInitializeOracleInstruction(instruction),
      };
    }
    case CpmmInstruction.InitializePool: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.InitializePool,
        ...parseInitializePoolInstruction(instruction),
      };
    }
    case CpmmInstruction.InitializeSpotPool: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.InitializeSpotPool,
        ...parseInitializeSpotPoolInstruction(instruction),
      };
    }
    case CpmmInstruction.InitializeSpotPoolWithHook: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.InitializeSpotPoolWithHook,
        ...parseInitializeSpotPoolWithHookInstruction(instruction),
      };
    }
    case CpmmInstruction.OracleConsult: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.OracleConsult,
        ...parseOracleConsultInstruction(instruction),
      };
    }
    case CpmmInstruction.OracleUpdate: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.OracleUpdate,
        ...parseOracleUpdateInstruction(instruction),
      };
    }
    case CpmmInstruction.Pause: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.Pause,
        ...parsePauseInstruction(instruction),
      };
    }
    case CpmmInstruction.PreviewSwapExactIn: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.PreviewSwapExactIn,
        ...parsePreviewSwapExactInInstruction(instruction),
      };
    }
    case CpmmInstruction.RedeemProtocolShares: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.RedeemProtocolShares,
        ...parseRedeemProtocolSharesInstruction(instruction),
      };
    }
    case CpmmInstruction.RemoveLiquidity: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.RemoveLiquidity,
        ...parseRemoveLiquidityInstruction(instruction),
      };
    }
    case CpmmInstruction.SetFees: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.SetFees,
        ...parseSetFeesInstruction(instruction),
      };
    }
    case CpmmInstruction.SetHook: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.SetHook,
        ...parseSetHookInstruction(instruction),
      };
    }
    case CpmmInstruction.SwapExactIn: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.SwapExactIn,
        ...parseSwapExactInInstruction(instruction),
      };
    }
    case CpmmInstruction.TransferAdmin: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.TransferAdmin,
        ...parseTransferAdminInstruction(instruction),
      };
    }
    case CpmmInstruction.Unpause: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.Unpause,
        ...parseUnpauseInstruction(instruction),
      };
    }
    case CpmmInstruction.UpdateConfig: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.UpdateConfig,
        ...parseUpdateConfigInstruction(instruction),
      };
    }
    case CpmmInstruction.WithdrawVaultExcess: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: CpmmInstruction.WithdrawVaultExcess,
        ...parseWithdrawVaultExcessInstruction(instruction),
      };
    }
    default:
      throw new SolanaError(
        SOLANA_ERROR__PROGRAM_CLIENTS__UNRECOGNIZED_INSTRUCTION_TYPE,
        { instructionType: instructionType as string, programName: 'cpmm' },
      );
  }
}

export type CpmmPlugin = {
  accounts: CpmmPluginAccounts;
  instructions: CpmmPluginInstructions;
};

export type CpmmPluginAccounts = {
  ammConfig: ReturnType<typeof getAmmConfigCodec> &
    SelfFetchFunctions<AmmConfigArgs, AmmConfig>;
  oracleState: ReturnType<typeof getOracleStateCodec> &
    SelfFetchFunctions<OracleStateArgs, OracleState>;
  pool: ReturnType<typeof getPoolCodec> & SelfFetchFunctions<PoolArgs, Pool>;
  position: ReturnType<typeof getPositionCodec> &
    SelfFetchFunctions<PositionArgs, Position>;
};

export type CpmmPluginInstructions = {
  addLiquidity: (
    input: AddLiquidityAsyncInput,
  ) => ReturnType<typeof getAddLiquidityInstructionAsync> &
    SelfPlanAndSendFunctions;
  closePosition: (
    input: ClosePositionInput,
  ) => ReturnType<typeof getClosePositionInstruction> &
    SelfPlanAndSendFunctions;
  collectFees: (
    input: CollectFeesAsyncInput,
  ) => ReturnType<typeof getCollectFeesInstructionAsync> &
    SelfPlanAndSendFunctions;
  collectProtocolFees: (
    input: CollectProtocolFeesAsyncInput,
  ) => ReturnType<typeof getCollectProtocolFeesInstructionAsync> &
    SelfPlanAndSendFunctions;
  createPosition: (
    input: MakeOptional<CreatePositionAsyncInput, 'payer'>,
  ) => ReturnType<typeof getCreatePositionInstructionAsync> &
    SelfPlanAndSendFunctions;
  initializeConfig: (
    input: MakeOptional<InitializeConfigAsyncInput, 'payer'>,
  ) => ReturnType<typeof getInitializeConfigInstructionAsync> &
    SelfPlanAndSendFunctions;
  initializeOracle: (
    input: MakeOptional<InitializeOracleAsyncInput, 'payer'>,
  ) => ReturnType<typeof getInitializeOracleInstructionAsync> &
    SelfPlanAndSendFunctions;
  initializePool: (
    input: MakeOptional<InitializePoolAsyncInput, 'payer'>,
  ) => ReturnType<typeof getInitializePoolInstructionAsync> &
    SelfPlanAndSendFunctions;
  initializeSpotPool: (
    input: MakeOptional<InitializeSpotPoolAsyncInput, 'payer'>,
  ) => ReturnType<typeof getInitializeSpotPoolInstructionAsync> &
    SelfPlanAndSendFunctions;
  initializeSpotPoolWithHook: (
    input: MakeOptional<InitializeSpotPoolWithHookAsyncInput, 'payer'>,
  ) => ReturnType<typeof getInitializeSpotPoolWithHookInstructionAsync> &
    SelfPlanAndSendFunctions;
  oracleConsult: (
    input: OracleConsultAsyncInput,
  ) => ReturnType<typeof getOracleConsultInstructionAsync> &
    SelfPlanAndSendFunctions;
  oracleUpdate: (
    input: OracleUpdateAsyncInput,
  ) => ReturnType<typeof getOracleUpdateInstructionAsync> &
    SelfPlanAndSendFunctions;
  pause: (
    input: PauseInput,
  ) => ReturnType<typeof getPauseInstruction> & SelfPlanAndSendFunctions;
  previewSwapExactIn: (
    input: PreviewSwapExactInInput,
  ) => ReturnType<typeof getPreviewSwapExactInInstruction> &
    SelfPlanAndSendFunctions;
  redeemProtocolShares: (
    input: RedeemProtocolSharesAsyncInput,
  ) => ReturnType<typeof getRedeemProtocolSharesInstructionAsync> &
    SelfPlanAndSendFunctions;
  removeLiquidity: (
    input: RemoveLiquidityAsyncInput,
  ) => ReturnType<typeof getRemoveLiquidityInstructionAsync> &
    SelfPlanAndSendFunctions;
  setFees: (
    input: SetFeesInput,
  ) => ReturnType<typeof getSetFeesInstruction> & SelfPlanAndSendFunctions;
  setHook: (
    input: SetHookInput,
  ) => ReturnType<typeof getSetHookInstruction> & SelfPlanAndSendFunctions;
  swapExactIn: (
    input: SwapExactInAsyncInput,
  ) => ReturnType<typeof getSwapExactInInstructionAsync> &
    SelfPlanAndSendFunctions;
  transferAdmin: (
    input: TransferAdminInput,
  ) => ReturnType<typeof getTransferAdminInstruction> &
    SelfPlanAndSendFunctions;
  unpause: (
    input: UnpauseInput,
  ) => ReturnType<typeof getUnpauseInstruction> & SelfPlanAndSendFunctions;
  updateConfig: (
    input: UpdateConfigInput,
  ) => ReturnType<typeof getUpdateConfigInstruction> & SelfPlanAndSendFunctions;
  withdrawVaultExcess: (
    input: WithdrawVaultExcessAsyncInput,
  ) => ReturnType<typeof getWithdrawVaultExcessInstructionAsync> &
    SelfPlanAndSendFunctions;
};

export type CpmmPluginRequirements = ClientWithRpc<
  GetAccountInfoApi & GetMultipleAccountsApi
> &
  ClientWithPayer &
  ClientWithTransactionPlanning &
  ClientWithTransactionSending;

export function cpmmProgram() {
  return <T extends CpmmPluginRequirements>(client: T) => {
    return {
      ...client,
      cpmm: <CpmmPlugin>{
        accounts: {
          ammConfig: addSelfFetchFunctions(client, getAmmConfigCodec()),
          oracleState: addSelfFetchFunctions(client, getOracleStateCodec()),
          pool: addSelfFetchFunctions(client, getPoolCodec()),
          position: addSelfFetchFunctions(client, getPositionCodec()),
        },
        instructions: {
          addLiquidity: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getAddLiquidityInstructionAsync(input),
            ),
          closePosition: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getClosePositionInstruction(input),
            ),
          collectFees: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getCollectFeesInstructionAsync(input),
            ),
          collectProtocolFees: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getCollectProtocolFeesInstructionAsync(input),
            ),
          createPosition: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getCreatePositionInstructionAsync({
                ...input,
                payer: input.payer ?? client.payer,
              }),
            ),
          initializeConfig: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getInitializeConfigInstructionAsync({
                ...input,
                payer: input.payer ?? client.payer,
              }),
            ),
          initializeOracle: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getInitializeOracleInstructionAsync({
                ...input,
                payer: input.payer ?? client.payer,
              }),
            ),
          initializePool: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getInitializePoolInstructionAsync({
                ...input,
                payer: input.payer ?? client.payer,
              }),
            ),
          initializeSpotPool: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getInitializeSpotPoolInstructionAsync({
                ...input,
                payer: input.payer ?? client.payer,
              }),
            ),
          initializeSpotPoolWithHook: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getInitializeSpotPoolWithHookInstructionAsync({
                ...input,
                payer: input.payer ?? client.payer,
              }),
            ),
          oracleConsult: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getOracleConsultInstructionAsync(input),
            ),
          oracleUpdate: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getOracleUpdateInstructionAsync(input),
            ),
          pause: (input) =>
            addSelfPlanAndSendFunctions(client, getPauseInstruction(input)),
          previewSwapExactIn: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getPreviewSwapExactInInstruction(input),
            ),
          redeemProtocolShares: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getRedeemProtocolSharesInstructionAsync(input),
            ),
          removeLiquidity: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getRemoveLiquidityInstructionAsync(input),
            ),
          setFees: (input) =>
            addSelfPlanAndSendFunctions(client, getSetFeesInstruction(input)),
          setHook: (input) =>
            addSelfPlanAndSendFunctions(client, getSetHookInstruction(input)),
          swapExactIn: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getSwapExactInInstructionAsync(input),
            ),
          transferAdmin: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getTransferAdminInstruction(input),
            ),
          unpause: (input) =>
            addSelfPlanAndSendFunctions(client, getUnpauseInstruction(input)),
          updateConfig: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getUpdateConfigInstruction(input),
            ),
          withdrawVaultExcess: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getWithdrawVaultExcessInstructionAsync(input),
            ),
        },
      },
    };
  };
}

type MakeOptional<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;
